import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Globe } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { Button } from "./ui/button"; // keep only if still used by mobile menu
import { SHOP_URL } from "../lib/i18n";
import { ShoppingBag } from "lucide-react";
import { useSiteImages } from "../hooks/use-site-images";

export function Header() {
  const { t, lang, toggleLang } = useLang();
  const siteImage = useSiteImages();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: t.nav.home, testid: "nav-home", end: true },
    { to: "/about", label: t.nav.about, testid: "nav-about" },
    { to: "/how-we-work", label: t.nav.how, testid: "nav-how" },
    { to: "/sectors", label: t.nav.sectors, testid: "nav-sectors" },
    { to: "/business-hub", label: t.nav.hub, testid: "nav-hub" },
    { to: "/design", label: t.nav.design, testid: "nav-design" },
    { to: "/projects", label: t.nav.projects, testid: "nav-projects" },
    { to: "/fabrication", label: t.nav.fabrication, testid: "nav-fab" },
    { to: "/maintenance", label: t.nav.maintenance, testid: "nav-maint" },
    { to: "/brands", label: t.nav.brands, testid: "nav-brands" },
    { to: "/branches", label: t.nav.branches, testid: "nav-branches" },
    { to: "/contact", label: t.nav.contact, testid: "nav-contact" },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-slate-200" data-testid="site-header">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link
  to="/"
  data-testid="brand-link"
  className="flex items-center shrink-0"
>
  <img
    src={
      lang === "en"
        ? siteImage("site_logo_en", "/assets/mariotlogoen.png")
        : siteImage("site_logo_ar", "/assets/mariotlogoar.png")
    }
    alt="Mariot Kitchen Equipment"
    className="h-11 w-auto object-contain"
  />
</Link>

        <nav className="hidden xl:flex items-center gap-5">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-[13px] font-medium whitespace-nowrap transition-colors duration-200 ${
                  isActive ? "text-[#0891b2]" : "text-slate-600 hover:text-[#0891b2]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={toggleLang}
            data-testid="lang-toggle"
            className="flex items-center gap-1.5 text-xs font-medium text-slate-600 hover:text-[#0891b2] border border-slate-200 hover:border-[#0891b2] px-3 py-2 rounded transition-colors"
          >
            <Globe className="w-3.5 h-3.5" />
            {lang === "en" ? "العربية" : "EN"}
          </button>
          
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="xl:hidden text-slate-700 p-2"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="px-6 py-5 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${l.testid}`}
                className={({ isActive }) =>
                  `text-sm font-medium ${isActive ? "text-[#0891b2]" : "text-slate-600"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/quote" onClick={() => setOpen(false)}>
              <Button className="bg-[#ef4444] hover:bg-[#dc2626] text-white w-full" data-testid="mobile-quote-btn">
                {t.nav.quote}
              </Button>
            </Link>
            <a href={SHOP_URL} target="_blank" rel="noreferrer" onClick={() => setOpen(false)}>
              <Button data-testid="mobile-shop-btn" className="bg-[#334155] hover:bg-[#0f172a] text-white w-full">
                <ShoppingBag className="w-4 h-4 me-2" /> {t.nav.shop}
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
